<!-- <p>descriptor-item works!</p> -->
<div *ngIf="descriptorObs$ | async as ch">
  <h5>{{ ch[0].descriptor_name }}</h5>
  <h5>Grupo: {{ ch[0].group_name }}</h5>
  <small>Tipo de dato: {{ ch[0].data_type }}</small>
</div>
